import { FileTypeGroup, FileTypesByGroup } from '../constants'

export const getAcceptAttrFromExtensions = (fileTypesGroup: FileTypeGroup) =>
  FileTypesByGroup[fileTypesGroup]
    .map((type) => {
      return type.extensions.replace(' ', ',')
    })
    .join(',')
